<template>
    <div id="contract_container"></div>
</template>

<script>

export default {
    name: 'app',
    data: () => ({
    }),
    methods: {
    }
}
</Script>